export default InAppBrowser = {
  open: (url) => {},
  isAvailable: () => {},
};
